import styled from 'styled-components'

export default styled.div`
  font-size: 38px;
  font-family: Roboto, sans-serif;
  letter-spacing: 0.6px;
  margin-bottom: 28px;
`
